<div
  [class]="
    isInpatientView() ? 'inpatients-header-body' : 'patients-header-body'
  "
>
  @if (!patientLoading) {
  <div fxLayout="row" class="w-100">
    <div fxLayout="col" fxLayoutAlign="flex-start center">
      <div class="split-lines pr-pp">
        <nz-avatar
          class="profilePicture"
          [nzShape]="'circle'"
          [nzSize]="80"
          nzIcon="user"
          [nzSrc]="avatarImageUrl"
        ></nz-avatar>
      </div>
    </div>
    <div
      fxLayout="col"
      class="split-lines pr-30"
      fxLayoutAlign="flex-start center"
    >
      <div fxLayout="row">
        <div class="header-details">
          @if (!episodeOfCare) {
          <div
            (click)="goToPatients()"
            class="header-patients"
            fxLayoutAlign="flex-start center"
          >
            {{ "Patient" | translate }} >
          </div>
          } @if (episodeOfCare && !isPilotStudy && !isInpatientView()) {
          <div
            (click)="goToProfile()"
            class="header-patients"
            fxLayoutAlign="flex-start center"
          >
            {{ "Profile" | translate }} >
          </div>
          }
          <div class="fullname">
            {{ patientInfo?.firstName }} {{ patientInfo?.lastName }}
          </div>
          <span class="custom-button" (click)="getPatientDetails()">
            @if (!showPatientInformation) {
            <mat-icon
              class="information-icon"
              nzTooltipTitle="{{ 'View patient information' | translate }}"
              nzTooltipPlacement="bottom"
              nz-tooltip
            >
              remove_red_eye
            </mat-icon>
            } @if (showPatientInformation) {
            <mat-icon
              class="information-icon"
              nzTooltipTitle="{{ 'Hide patient information' | translate }}"
              nzTooltipPlacement="bottom"
              nz-tooltip
            >
              visibility_off
            </mat-icon>
            }
          </span>
          @if (patientAdmissionReasonSummary) {
          <span class="custom-button" (click)="openAdmissionReasonSummary()">
            <mat-icon
              class="information-icon"
              nzTooltipTitle="{{ 'Admission details' | translate }}"
              nzTooltipPlacement="right"
              nz-tooltip
            >
              info
            </mat-icon>
          </span>
          }
        </div>
      </div>
      @if (!patientLoading) {
      <div fxLayout="row wrap" class="header-details-2">
        @if (patientInfo?.dateOfBirth) {
        <div>
          <span
            fxHide.gt-md
            nz-tooltip
            nzTooltipTitle="{{ 'y/o' | translate }}"
          >
            {{ calculateAge(patientInfo?.dateOfBirth!) }}
          </span>
          <span fxHide.lt-lg>
            {{ calculateAge(patientInfo?.dateOfBirth!) }}
            {{ "y/o" | translate }}</span
          >
        </div>
        } @if (patientInfo?.gender) {
        <div>
          <span class="divider">|</span>
          {{ patientInfo?.gender! | translate }}
        </div>
        } @if (patientInfo?.height) {
        <div>
          <span class="divider">|</span>
          <span fxHide.gt-md nz-tooltip nzTooltipTitle="{{ 'cm' | translate }}">
            {{ patientInfo?.height }}
          </span>
          <span fxHide.lt-lg>
            {{ patientInfo?.height }} {{ "(cm)" | translate }}</span
          >
        </div>
        } @if (patientInfo?.weight) {
        <div>
          <span class="divider">|</span>
          <span fxHide.gt-md nz-tooltip nzTooltipTitle="{{ 'kg' | translate }}">
            {{ patientInfo?.weight }}
          </span>
          <span fxHide.lt-lg>
            {{ patientInfo?.weight }} {{ "(kg)" | translate }}</span
          >
        </div>
        } @if (patientInfo?.weight && patientInfo?.height) {
        <div>
          <span class="divider">|</span>
          <span
            fxHide.gt-md
            nz-tooltip
            nzTooltipTitle="{{ 'BMI' | translate }}"
          >
            {{ calculatePatientBMI(patientInfo?.weight, patientInfo?.height) }}
          </span>
          <span fxHide.lt-lg>
            {{ "BMI: " | translate }}
            {{
              calculatePatientBMI(patientInfo?.weight, patientInfo?.height)
            }}</span
          >
        </div>
        }
      </div>
      }
    </div>
    <div fxLayout="col" class="split-lines" fxLayoutAlign="flex-start center">
      @if (!patientLoading) {
      <div fxLayout="row">
        <div class="header-details">
          <div class="header-details-2 pl-5">
            @if (patientInfo?.bloodType) {
            <div>
              <i
                nz-icon
                nzType="icons:blood"
                nzTheme="outline"
                class="header-icon pr-5"
              ></i>
              {{ getBloodtype(patientInfo?.bloodType) }}
            </div>
            } @if (patientInfo?.bloodType && patientInfo?.assignedDoctors) {
            <span class="divider">|</span>
            } @if ( patientInfo?.assignedDoctors &&
            getPrimaryDoctor()?.doctorFullName ) {
            <div fxLayout="row">
              <i
                nz-icon
                nzType="icons:doctor"
                nzTheme="outline"
                class="pr-10"
              ></i>
              {{ getPrimaryDoctor()?.doctorFullName }} (Primary)
            </div>
            }
          </div>
        </div>
      </div>
      } @if (!patientLoading) {
      <div fxLayout="row wrap" class="header-details-2 pl-5">
        @if (patientInfo?.inPatientDto?.buildingName) {
        <div class="item">
          <i nz-icon nzType="icons:bed" nzTheme="outline" class="pr-10"></i>
          {{ patientInfo?.inPatientDto?.buildingName }}
        </div>
        } @if (patientInfo?.inPatientDto?.floorName) {
        <div class="item">
          <span class="divider">|</span>
          {{ patientInfo?.inPatientDto?.floorName }}
        </div>
        } @if (patientInfo?.inPatientDto?.wardName) {
        <div class="item">
          <span class="divider">|</span>
          {{ patientInfo?.inPatientDto?.wardName }}
        </div>
        } @if (patientInfo?.inPatientDto?.bedNumber) {
        <div class="item">
          <span class="divider">|</span>
          {{ patientInfo?.inPatientDto?.bedNumber }}
        </div>
        } &nbsp;
      </div>
      }
    </div>
    <div
      fxLayout="col"
      fxFlex="auto"
      class="split-lines"
      fxLayoutAlign="flex-start center"
    >
      <div fxLayout="row">
        <div fxLayout="col" fxFlex fxLayoutAlign="flex-end center">
          @if (!episodeOfCare && !isReadOnly && !isComingFromInPatient) {
          <button
            nz-button
            class="add-episode"
            (click)="addEpisodeOfCare()"
            [nzLoading]="isEOCloading"
          >
            <mat-icon>{{ "add" | translate }}</mat-icon>
            <span class="btn-text">{{
              "Add Episode of Care" | translate
            }}</span>
          </button>
          } @if (episodeOfCare && (isEOC() || isInpatientView()) && !isPreview)
          {
          <button nz-button class="discard-button" (click)="discardVisit()">
            <i nz-icon nzType="icons:delete" nzTheme="outline"></i
            ><span class="btn-text">{{ "Discard" | translate }}</span>
          </button>
          } @if (episodeOfCare && (isEOC() || isInpatientView()) && !isPreview)
          {
          <button nz-button class="preview-button" (click)="loadPreview()">
            <i nz-icon nzType="icons:eye" nzTheme="outline"></i>
            <span class="btn-text">{{ "Preview & Save" | translate }}</span>
          </button>
          } @if (episodeOfCare && (isEOC() || isInpatientView()) && isPreview) {
          <button nz-button class="back-button" (click)="unloadPreview()">
            <i nz-icon nzType="icons:rollback" nzTheme="outline"></i>
            <span class="btn-text">{{ "Back" | translate }}</span>
          </button>
          } @if ( episodeOfCare && (isEOC() || isInpatientView()) && isPreview
          && previewValid ) {
          <button
            nz-button
            class="save-button"
            [ngClass]="{ 'save-button-hover': potentialDiagnosis }"
            (click)="saveVisit()"
            [disabled]="!potentialDiagnosis"
          >
            <i nz-icon nzType="icons:save" nzTheme="outline"></i>
            <span class="btn-text">{{ "Save Visit" | translate }}</span>
          </button>
          }
          <!-- Add this button somewhere in your header actions toolbar -->
          <!-- @if (patientAdmissionReasonSummary) {
          <button
            nz-button
            class="save-button"
            (click)="openAdmissionReasonSummary()"
          >
            <i nz-icon nzType="icons:info" nzTheme="outline"></i>
            <span class="btn-text">{{ "Admission details" | translate }}</span>
          </button>
          } -->
        </div>
      </div>
    </div>
  </div>
  }
</div>

<div *ngComponentOutlet="admissionReasonSummaryComponent"></div>
